import { render, staticRenderFns } from "./PaymentInstructions.vue?vue&type=template&id=db9608be&scoped=true&"
import script from "./PaymentInstructions.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInstructions.vue?vue&type=style&index=0&id=db9608be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9608be",
  null
  
)

export default component.exports